module.exports = __webpack_public_path__ + "img/1488701793.581c98f9.jpg";